/* Shared building blocks for ArmIQ How-To guides. */
import { Link } from "react-router-dom";

export function Section({ title, kicker, children, id }) {
  return (
    <section id={id} className="scroll-mt-24" data-testid={`section-${id}`}>
      {kicker && <div className="text-[10px] tracking-[0.3em] font-bold text-white/40 uppercase">{kicker}</div>}
      <h2 className="font-display font-black text-2xl md:text-3xl tracking-tighter text-white mt-1">{title}</h2>
      <div className="mt-4 space-y-4 text-white/80 leading-relaxed">{children}</div>
    </section>
  );
}

export function Step({ n, title, children }) {
  return (
    <div className="rounded-xl ink-card p-5 flex gap-4">
      <div className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center font-display font-black text-white text-base"
           style={{ backgroundColor: "var(--brand-secondary)" }}>
        {n}
      </div>
      <div className="flex-1">
        <div className="font-display font-bold text-white text-base">{title}</div>
        <div className="text-sm text-white/70 mt-1 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

export function Callout({ kind = "info", title, children }) {
  const palette = {
    info:    { bg: "rgba(34,211,238,0.12)", border: "rgba(34,211,238,0.4)", color: "#22D3EE" },
    warn:    { bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.4)", color: "#F59E0B" },
    danger:  { bg: "rgba(239,68,68,0.12)",  border: "rgba(239,68,68,0.4)",  color: "#EF4444" },
    good:    { bg: "rgba(22,163,74,0.12)",  border: "rgba(22,163,74,0.4)",  color: "#16A34A" },
  }[kind];
  return (
    <div className="rounded-lg p-4" style={{ backgroundColor: palette.bg, border: `1px solid ${palette.border}` }}>
      {title && <div className="text-[10px] tracking-[0.3em] font-bold uppercase mb-1.5" style={{ color: palette.color }}>{title}</div>}
      <div className="text-sm text-white/85">{children}</div>
    </div>
  );
}

export function KeyTerm({ term, children }) {
  return (
    <div className="rounded-lg p-4 ink-card">
      <div className="font-display font-bold text-white">{term}</div>
      <div className="text-sm text-white/70 mt-1">{children}</div>
    </div>
  );
}

export function TOC({ items }) {
  return (
    <nav className="rounded-xl ink-card p-5 sticky top-24" data-testid="guide-toc">
      <div className="text-[10px] tracking-[0.3em] font-bold text-white/40 uppercase">On this page</div>
      <ol className="mt-3 space-y-2 list-decimal list-inside text-sm">
        {items.map((it) => (
          <li key={it.id}>
            <a href={`#${it.id}`} className="text-white/70 hover:text-white">{it.title}</a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function Pill({ children, color }) {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold tracking-[0.05em]"
          style={{ backgroundColor: `${color}1f`, color, border: `1px solid ${color}55` }}>
      {children}
    </span>
  );
}
